import CryptoJS from 'crypto-js';

const SECRET = process.env.GATSBY_SECRET;

export const encrypt = (message: unknown): string | void => {
  if (!SECRET) {
    throw new Error('Please, provide a "SECRET"');
  }
  const messageToEncrypt = typeof message === 'string' ? message : JSON.stringify(message);
  return CryptoJS.RC4.encrypt(messageToEncrypt, SECRET).toString();
};

export const decrypt = (encryptedMessage: string): string => {
  if (!SECRET) {
    throw new Error('Please, provide a "SECRET"');
  }

  try {
    const bytes = CryptoJS.RC4.decrypt(encryptedMessage, SECRET);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    return '';
  }
};
